/* eslint-disable arrow-body-style */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Grid from '../../../../components/Grid/Grid';
import Typography from '../../../../components/Typography/Typography';
import InputField from '../../../../components/InputField/InputField';
import SelectField from '../../../../components/SelectField/SelectField';

const StartTransferFormingForm = ({
  formData,
  handleFormChange,
  formErr,
  machineList,
  materialList,
  setFormData,
  disabled,
}) => {
  return (
    <Grid container direction="column" gap={3} sx={{ py: 1 }}>
      <Typography variant="subtitle1">請填製造資訊</Typography>
      <Grid item size={12}>
        <SelectField
          label="實際粉料材質 / Bahan"
          placeholder="請選擇材質 / Bahan"
          id="materialId"
          value={formData.materialId}
          handleChange={(e) => {
            handleFormChange(e);
            setFormData((prev) => ({
              ...prev,
              materialName: materialList.find((item) => item.value === e.target.value)?.name,
            }));
          }}
          name="materialId"
          selections={materialList}
          error={formErr.materialId}
          errormsg="請選擇實際粉料材質 / Bahan！"
          disabled={disabled}
        />
      </Grid>
      <Grid item size={12}>
        <InputField
          id="bucketNo"
          label="桶號 / Nomor barel"
          value={formData.bucketNo}
          onChange={handleFormChange}
          placeholder="請輸入桶號 / Nomor barel"
          type="text"
          name="bucketNo"
          error={formErr.bucketNo}
          errormsg="請輸入正確的桶號 / Nomor barel"
          fullWidth
          disabled={disabled}
        />
      </Grid>
      <Grid item size={12}>
        <SelectField
          label="壓型機台 / Mesin pembentuk"
          placeholder="請選擇壓型機台 / Mesin pembentuk"
          id="machineId"
          value={formData.machineId}
          handleChange={(e) => {
            handleFormChange(e);
            setFormData((prev) => ({
              ...prev,
              machineName: machineList.find((item) => item.value === e.target.value)?.name,
            }));
          }}
          name="machineId"
          selections={machineList}
          error={formErr.machineId}
          errormsg="請選擇壓型機台 / Mesin pembentuk！"
          disabled={disabled}
        />
      </Grid>
    </Grid>
  );
};

StartTransferFormingForm.propTypes = {
  formData: PropTypes.shape({
    bucketNo: PropTypes.string.isRequired,
    materialName: PropTypes.string.isRequired,
    materialId: PropTypes.string.isRequired,
    pilotTransferQty: PropTypes.string.isRequired,
    machineId: PropTypes.string.isRequired,
    isPQCPilot: PropTypes.bool.isRequired,
    remark: PropTypes.string.isRequired,
  }).isRequired,
  handleFormChange: PropTypes.func.isRequired,
  setFormData: PropTypes.func.isRequired,
  formErr: PropTypes.shape({
    bucketNo: PropTypes.bool.isRequired,
    materialName: PropTypes.bool.isRequired,
    materialId: PropTypes.bool.isRequired,
    pilotTransferQty: PropTypes.bool.isRequired,
    machineId: PropTypes.bool.isRequired,
    isPQCPilot: PropTypes.bool.isRequired,
    remark: PropTypes.bool.isRequired,
  }).isRequired,
  machineList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  materialList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default StartTransferFormingForm;
